"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "Marcus Vane",
  quote: "PulseWave didn't just record my track; they captured the soul of the performance with surgical precision.",
  position: "Independent Producer"
}, {
  author: "Elena Thorne",
  quote: "The atmosphere here is electric. It's the only studio where the gear matches the creative energy of the room.",
  position: "Vocalist & Songwriter"
}];
export default function VoicesOfTheElite() {
  return <section data-section-id="245651" id="artist-voices" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden flex items-center min-h-[80vh]">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/studio_lounge_blur.png)] bg-cover bg-center opacity-10 mix-blend-screen pointer-events-none"></div>
      
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center px-6 md:px-20 py-10">
                  {}
                  <Quote className="w-20 h-20 md:w-32 md:h-32 text-primary/10 mb-8 md:mb-12 fill-primary/5" strokeWidth={1} />
                  
                  {}
                  <p className="text-2xl md:text-4xl lg:text-5xl font-serif italic text-center leading-relaxed md:leading-tight mb-10 md:mb-16 text-foreground/95 tracking-tight">
                    "{testimonial.quote}"
                  </p>
                  
                  {}
                  <div className="text-center flex flex-col items-center gap-2">
                    <div className="w-12 h-[1px] bg-primary/30 mb-4"></div>
                    <h4 className="text-xl md:text-2xl font-default font-bold text-primary tracking-tighter">
                      {testimonial.author}
                    </h4>
                    <p className="text-xs md:text-sm font-mono text-muted-foreground uppercase tracking-[0.3em]">
                      {testimonial.position}
                    </p>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          {}
          <div className="hidden md:block">
            <CarouselPrevious className="border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground size-14 -left-4 lg:-left-12 transition-all duration-500 bg-background/40 backdrop-blur-md rounded-full shadow-lg shadow-primary/10" />
            <CarouselNext className="border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground size-14 -right-4 lg:-right-12 transition-all duration-500 bg-background/40 backdrop-blur-md rounded-full shadow-lg shadow-primary/10" />
          </div>
        </Carousel>
      </div>
    </section>;
}